import { graphql } from '@/gql'

/** Unfiltered People totals; the page's People tab badge and the segment badges read it. Agencies see no client team. */
export const ClientPeopleCountsQuery = graphql(`
  query ClientPeopleCounts($client: ID!, $accounts: [ID!], $companyRelation: Boolean = true) {
    team: clientRelationOwners(client: $client, accounts: $accounts, first: 1) {
      paginatorInfo {
        total
      }
    }
    recruiters: clientRelationCounterpartOwners(client: $client, accounts: $accounts, first: 1) {
      paginatorInfo {
        total
      }
    }
    clientTeam: clientRelationTeam(client: $client, accounts: $accounts, first: 1)
      @include(if: $companyRelation) {
      paginatorInfo {
        total
      }
    }
    relation: clientRelation(id: $client) {
      id
      ... on CompanySupplier {
        linkedStaffingAgencies(first: 1) {
          paginatorInfo {
            total
          }
        }
      }
    }
  }
`)
